import Vue from 'vue'
import { getVal } from '@/utils/index'

Vue.prototype.$getVal = getVal
